import React from "react";
import { Stack } from "@mui/material";

import { CommentSection } from "../../../components/Comments";
import { useUserHookFormList } from "../../../components/UsersHookFormSelect/useUserHookFormList";

const CommentsTab = ({ quoteId, currentUserId }) => {
  const { users } = useUserHookFormList();

  return (
    <Stack
      sx={{
        flex: 1,
        minHeight: 0,
        overflowY: "auto",
        overflowX: "hidden",
        "::-webkit-scrollbar": {
          display: "none !important",
        },
      }}
    >
      <CommentSection
        resourceType="quote"
        resourceId={quoteId}
        currentUserId={currentUserId}
        users={users}
      />
    </Stack>
  );
};

export default CommentsTab;
